import React from 'react';
import Footer from '../../components/Footer/Footer';
import HomeHero from '../../components/HomeHero/HomeHero';
import Navbar from '../../components/Navbar/Navbar';
import About from './About';
import Contact from './Contact';
import Support from './Support';

const Home = () => {
    return (
        <div>
            <Navbar />
            <HomeHero />
        </div>
    );
};

export default Home;